<template>
  <div class="filters">
    <template v-for="(filter, index) in filters" :key="index">
      <component
          v-model:searchParams="searchParams"
          :is="filter"
      />
    </template>
    <div class="searchButtons">
      <ExtendedSearch
        :table-model="tableModel"
        :search-params="searchParams"
        @search="search"
        @reset-search="resetForm"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ExtendedSearch from '@intec/vue-components/search/ExtendedSearch.vue';
import { useApiEventsLogComponentStore } from '@/stores/apiEventsLogComponentStore.js';

const { tableModel } = defineProps({
  tableModel: {
    type: Object,
    required: true,
  },
});

const searchParams = ref({});

const { getFilters } = useApiEventsLogComponentStore();
const filters = getFilters();

const search = () => {
  tableModel.bind.options.page = 1;
  tableModel.reload({searchParams});
}

const resetForm = () => {
  searchParams.value = {};
  tableModel.reload();
}
</script>

<style scoped>
.filters {
  align-items: end;
  display: flex;
  flex-direction: row;
  gap: 44px;
  padding: 19px 0 6px 0;
}

.filters > * {
  display: flex;
  flex-direction: column;
  font-family: Abrade;
  font-weight: 500;
  gap: 15px;
  width: 100%;
}

:deep(.mx-input) {
  background-color: rgb(var(--white-color));
  border: 1px solid rgb(var(--grey-border-color));
  border-radius: 8px;
  box-shadow: none;
  font-size: 12px;
  height: 40px;
  padding-left: 11px;
  &::placeholder {
    color: rgba(var(--black-color), 0.4);
    opacity: unset;
    font-size: 12px;
  };
}

:deep(.v-input) {
  background-color: rgb(var(--white-color));
  border: 1px solid rgb(var(--grey-border-color));
  border-radius: 8px;
  padding: 0 !important;
  width: 100%;
}

:deep(.v-field) {
  box-shadow: none;
  font-weight: 500;
  line-height: 20px;
  padding: 0;
  width: 100%;
}

:deep(.v-field__input) {
  align-content: center;
  font-size: 12px;
  height: 38px;
  min-height: auto;
  padding: 0 17px;
  width: 100%;
  &::placeholder {
    color: rgba(var(--black-color), 0.5);
    opacity: unset;
    font-size: 12px;
  };
}

:deep(.v-field__input input) {
  align-self: center !important;
  &::placeholder {
    color: rgba(var(--black-color), 0.5);
    opacity: unset;
    font-size: 12px;
  };
}

:deep(.searchButtons .buttons) {
  justify-content: flex-start;
}

:deep(.mx-datepicker) {
  .mx-input {
    width: 210px;
  }
}

:deep(.searchButtons) {
  .searchButton:not(.resetButton) {
    margin-left: 0!important;
    padding: 10px 30px;
  }
}
</style>

<style>
.api-events-page-select-filter-list {
  padding: 0;
}

.api-events-page-select-filter-list .v-list-item-title {
  font-family: Abrade;
  font-size: 12px;
  font-weight: 500;
}
</style>
